import React, { useState, useEffect } from "react";
import TrackingLogs from "./TrackingLogs.jsx";
import CodInfo from "./CodInfo.jsx";
import OperationLogs from "./OperationLogs.jsx";
import { apiUrl } from "../config.js";
import axios from "axios";

const DeliveryDetailsFull = ({ deliveryId }) => {
  const [orderDetailsData, setOrderDetailsData] = useState();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        `${apiUrl}Delivery/OrderDetails?deliveryId=${deliveryId}`
      );
      console.log(response);
      setOrderDetailsData(response.data[0]); // added [0] because new route returns an array, ***not sure which index is the one we are going to with, (0 or length-1)
    };
    fetchData();
  }, [deliveryId]);

  return (
    <div>
      {/* <table className='table table-sm' style={{maxWidth:700}}>
                <tr>
                    <td>Delivery ID</td>
                    <td>{orderDetailsData?.deliveryInfo?.deliveryId ?? ""}</td>
                </tr>
                <tr>
                    <td>Invoice Number</td>
                    <td>{orderDetailsData?.deliveryInfo?.invoiceNumber ?? ""}</td>
                </tr>
                <tr>
                    <td>Delivery Date</td>
                    <td>{orderDetailsData?.deliveryInfo?.deliveryDate ?? ""}</td>
                </tr>
                <tr>
                    <td>Creation Date</td>
                    <td>{orderDetailsData?.deliveryInfo?.creationDate ?? ""}</td>
                </tr>
                <tr>
                    <td>Customer</td>
                    <td>
                        {orderDetailsData?.deliveryInfo?.customerName}<br />
                        {orderDetailsData?.deliveryInfo?.customerAddress}<br />
                        {orderDetailsData?.deliveryInfo?.customerCity}, {orderDetailsData?.deliveryInfo?.customerState} {orderDetailsData?.deliveryInfo?.customerZip}
                    </td>
                </tr>
                <tr>
                    <td>Route</td>
                    <td>{orderDetailsData?.deliveryInfo?.route ?? ""}</td>
                </tr>
                <tr>
                    <td>Piece Count</td>
                    <td>{orderDetailsData?.deliveryInfo?.pieceCount ?? ""}</td>
                </tr>
                <tr>
                    <td>COD</td>
                    <td>{orderDetailsData?.deliveryInfo?.isCod ? "Yes" : "No"}</td>
                </tr>
                <tr>
                    <td>Cod Amount</td>
                    <td>{orderDetailsData?.deliveryInfo?.codAmount ?? ""}</td>
                </tr>
                <tr>
                    <td>Delivery Type</td>
                    <td>{orderDetailsData?.deliveryInfo?.deliveryType ?? ""}</td>
                </tr>
                <tr>
                    <td>Status</td>
                    <td>{orderDetailsData?.deliveryInfo?.status ?? ""}</td>
                </tr>
                <tr>
                    <td>Comments</td>
                    <td>{orderDetailsData?.deliveryInfo?.comment ?? ""}</td>
                </tr>
            </table> */}
      <dl className="row" style={{ maxWidth: 400 }}>
        <dt className="col-sm-6">Delivery ID</dt>
        <dd className="col-sm-6">
          {orderDetailsData?.deliveryInfo?.deliveryId ?? ""}
        </dd>

        <dt className="col-sm-6">Invoice Number</dt>
        <dd className="col-sm-6">
          {orderDetailsData?.deliveryInfo?.invoiceNumber ?? ""}
        </dd>

        <dt className="col-sm-6">Delivery Date</dt>
        <dd className="col-sm-6">
          {orderDetailsData?.deliveryInfo?.deliveryDate ?? ""}
        </dd>

        <dt className="col-sm-6">Creation Date</dt>
        <dd className="col-sm-6">
          {orderDetailsData?.deliveryInfo?.creationDate ?? ""}
        </dd>

        <dt className="col-sm-6">Customer</dt>
        <dd className="col-sm-6">
          {orderDetailsData?.deliveryInfo?.customerName}
          <br />
          {orderDetailsData?.deliveryInfo?.customerAddress}
          <br />
          {orderDetailsData?.deliveryInfo?.customerCity},{" "}
          {orderDetailsData?.deliveryInfo?.customerState}{" "}
          {orderDetailsData?.deliveryInfo?.customerZip}
        </dd>

        <dt className="col-sm-6">Route</dt>
        <dd className="col-sm-6">
          {orderDetailsData?.deliveryInfo?.route ?? ""}
        </dd>

        <dt className="col-sm-6">Piece Count</dt>
        <dd className="col-sm-6">
          {orderDetailsData?.deliveryInfo?.pieceCount ?? ""}
        </dd>

        <dt className="col-sm-6">COD</dt>
        <dd className="col-sm-6">
          {orderDetailsData?.deliveryInfo?.isCod ? "Yes" : "No"}
        </dd>

        <dt className="col-sm-6">COD Amount</dt>
        <dd className="col-sm-6">
          {orderDetailsData?.deliveryInfo?.codAmount ?? ""}
        </dd>

        <dt className="col-sm-6">Delivery Type</dt>
        <dd className="col-sm-6">
          {orderDetailsData?.deliveryInfo?.deliveryType ?? ""}
        </dd>

        <dt className="col-sm-6">Status</dt>
        <dd className="col-sm-6">
          {orderDetailsData?.deliveryInfo?.status ?? ""}
        </dd>

        <dt className="col-sm-6">Comments</dt>
        <dd className="col-sm-6">
          {orderDetailsData?.deliveryInfo?.comment ?? ""}
        </dd>
      </dl>
      {orderDetailsData?.trackingItems && (
        <TrackingLogs trackingItems={orderDetailsData.trackingItems} />
      )}
      {orderDetailsData?.codDetails && (
        <CodInfo codDetails={orderDetailsData.codDetails} />
      )}
      {orderDetailsData?.operationLogs && (
        <OperationLogs operationLogs={orderDetailsData.operationLogs} />
      )}
    </div>
  );
};

export default DeliveryDetailsFull;
